import React from 'react';
import './Loading.scss';

export const Loading = (): React.ReactElement => {
    return (
        <div className="loader-container">
            <div className="spinner-border Loading-Spinner" role="status">
                {/* <span className="sr-only">Loading...</span> */}
            </div>
        </div>
    );
};
